import { DEFAULT_PAGING_DISPLAYED_RANGE } from '../../global/constants';
import { ModerationListSortOrder } from './types';

export const defaultSortOrder: ModerationListSortOrder = ModerationListSortOrder.name;

export const PAGE_SIZE = 15;
export const PAGING_DISPLAYED_RANGE = DEFAULT_PAGING_DISPLAYED_RANGE;
